import styled from "styled-components";
import { remCalc } from "../../../theme/style-utils-coras-nua";
import BaseChoiceStyle from "./base-choices";
import defaultTheme from "../../../theme/theme-test-override";

const StyledCheckbox = styled(BaseChoiceStyle)`
    .field-label {
        padding-left: ${remCalc(36)};
        margin-bottom: ${remCalc(12)};
        display: block;
        color: ${props => props.theme.colors.monotoneDark};
        cursor: pointer;
        strong {
            font-weight: ${props => props.theme.fontWeights.semiBold};
        }
        &:before {
            background-color: ${props => props.theme.colors.monotoneMidLight};
            color: ${props => props.theme.colors.monotoneMidLight};
            border: ${remCalc(1)} solid
                ${props => props.theme.colors.monotoneDark};
            width: ${remCalc(22)};
            height: ${remCalc(22)};
            line-height: ${remCalc(22)};
            position: absolute;
            left: 0;
            content: " ";
        }
    }
    ${"" /* FOCUS state styling: */}
    input:focus + label,
        input:focus ~ label {
        &:before {
            outline: none;
            box-shadow: 0 0 ${remCalc(2)} ${remCalc(2)}
                ${props => props.theme.colors.primary};
            transition: box-shadow 150ms ease-in;
            @media (-webkit-min-device-pixel-ratio: 0) {
                outline: none;
                box-shadow: 0 0 ${remCalc(2)} ${remCalc(2)}
                    ${props => props.theme.colors.primary};
            }
        }
    }
    input:checked + label,
    input:checked ~ label {
        &:before {
            background-color: ${props => props.theme.colors.brilliant};
            color: ${props => props.theme.colors.primary};
            font-size: ${remCalc(0.7)};
            border: ${remCalc(1)} solid ${props => props.theme.colors.primary};
            ${"" /* background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDJweCIgaGVpZ2h0PSIzMXB4IiB2aWV3Qm94PSIwIDAgNDIgMzEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjEgKDcyNjMxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5jaGVja2JveC1jaGVja2VkPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9ImNoZWNrYm94LWNoZWNrZWQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0xNC4yNjUwOTk4LDMwLjM5MTE1OTUgTDAuNjE1MDU0NzE3LDE2Ljg4MDU2OCBDLTAuMjA1MDE4MjM5LDE2LjA2ODg3MzIgLTAuMjA1MDE4MjM5LDE0Ljc1MjgxMjggMC42MTUwNTQ3MTcsMTMuOTQxMDM4NyBMMy41ODQ4NDUxNSwxMS4wMDE1MDk0IEM0LjQwNDkxODEsMTAuMTg5NzM1MyA1LjczNDY0MjczLDEwLjE4OTczNTMgNi41NTQ3MTU2OSwxMS4wMDE1MDk0IEwxNS43NDk5OTUsMjAuMTAyODQ2NiBMMzUuNDQ1Mjg0MywwLjYwODc3MTEwNiBDMzYuMjY1MzU3MywtMC4yMDI5MjM3MDIgMzcuNTk1MDgxOSwtMC4yMDI5MjM3MDIgMzguNDE1MTU0OSwwLjYwODc3MTEwNiBMNDEuMzg0OTQ1MywzLjU0ODMwMDQyIEM0Mi4yMDUwMTgyLDQuMzU5OTk1MjMgNDIuMjA1MDE4Miw1LjY3NjA1NTY0IDQxLjM4NDk0NTMsNi40ODc4Mjk3NCBMMTcuMjM0ODkwMiwzMC4zOTEyMzg4IEMxNi40MTQ3MzcxLDMxLjIwMjkzMzYgMTUuMDg1MDkyNiwzMS4yMDI5MzM2IDE0LjI2NTA5OTgsMzAuMzkxMTU5NSBaIiBpZD0iYyIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg=="); */}
            background-image: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='18px' height='13px' viewBox='0 0 18 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Templates' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpolyline id='Path-2' stroke='%23000DFF' stroke-width='2' points='1.5 6 7 11.5 16.5 1'%3E%3C/polyline%3E%3C/g%3E%3C/svg%3E");
            background-size: ${remCalc(18)};
            background-repeat: no-repeat;
            background-position: center center;
        }
    }
    .checkbock-disabled {
        opacity: 0.4;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+/Edge */
        user-select: none; /* Standard */
    }
`;
StyledCheckbox.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

export default StyledCheckbox;
